import React from 'react';

import { Typography } from '@material-ui/core';
import Page from '../page/Page';

const ShippingRatesPage = () => (
  <Page>
    <Typography variant="h2">Rates ~ TBD</Typography>
  </Page>
);

export default ShippingRatesPage;
